import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { BRAND } from "../lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ink text-white overflow-hidden grain">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 pt-20 pb-10">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="Bright & Tide" className="h-12 w-12 rounded-full object-cover" />
            <span className="font-heading font-extrabold text-xl">Bright <span className="text-tide-bright">&amp; Tide</span></span>
          </div>
          <p className="text-white/60 max-w-sm leading-relaxed">
            Spotless Spaces. Healthier Places. Better Impressions. Insured, bonded and background-checked
            cleaning for offices, restaurants and homes across the Greater Toronto Area.
          </p>
          <div className="flex items-center gap-2 mt-6 text-tide-bright text-sm font-semibold">
            <ShieldCheck size={18} /> Insured &amp; Bonded · Background-Checked Staff
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-white/40 mb-5">Company</h4>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/services" className="hover:text-tide-bright transition-colors">Services &amp; Pricing</Link></li>
            <li><Link to="/book" className="hover:text-tide-bright transition-colors">Book Now</Link></li>
            <li><Link to="/about" className="hover:text-tide-bright transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-tide-bright transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-white/40 mb-5">Get in Touch</h4>
          <ul className="space-y-3 text-white/70">
            <li><a href={BRAND.phoneHref} className="flex items-center gap-2 hover:text-tide-bright transition-colors"><Phone size={16} /> {BRAND.phone}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-tide-bright transition-colors"><Mail size={16} /> {BRAND.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-1" /> Greater Toronto Area</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4 text-white/40 text-sm">
        <span>© {new Date().getFullYear()} Bright &amp; Tide Cleaning. All rights reserved.</span>
        <span>Reliable. Professional. Exceptional.</span>
      </div>
    </div>
    <div className="pointer-events-none select-none w-full overflow-hidden">
      <div className="text-[16vw] leading-[0.8] font-heading font-extrabold text-white/[0.04] text-center whitespace-nowrap -mb-4">
        BRIGHT &amp; TIDE
      </div>
    </div>
  </footer>
);
